// extracted by mini-css-extract-plugin
export default {"container":"container---lLHol","link":"link---HPazS","externalLink":"externalLink---hTY1E"};